import React, { memo, useEffect, useState } from 'react'
import { Button, useTheme, useMediaQuery } from '@material-ui/core'
import { debounce } from 'lodash';
import GlobalStyle from 'styles/globalStyle'
import * as Styled from './styled'
import ThemeProvider from 'theme'
import Header from '../Header'
import Footer from '../Footer'
import FixedFooter from '../FixedFooter'
import { ReactComponent as FixedFooterIcon } from 'svgs/fixed-footer-arrow.svg'
import { Provider as SnackbarProvider } from '../Snackbar/Context'


const Layout = ({ children, firstPlan, affiliate, hideFixedFooter }) => {
  const isIPad = useMediaQuery(useTheme().breakpoints.up('md'))
  const [showDefaultFixedFooter, toggleFixedFooter] = useState(true)
  const [footerPrice, setFooterPrice] = useState({})

  const getSectionArea = ({ id, onlyTop }) => {
    const el = document.querySelector(`#${id}`);
    const calc = () => onlyTop ? el.offsetTop : el.offsetTop + el.offsetHeight;
    return el ? calc() : 0;
  }

  useEffect(() => {
    const handleScroll = () => {
      const planSectionArea = getSectionArea({ id: 'plansSection' })
      const knowWDentalArea = getSectionArea({ id: 'knowWDental', onlyTop: true })
      toggleFixedFooter(window.pageYOffset >= planSectionArea || window.pageYOffset <= knowWDentalArea)
    }
    const debouncedHandleScroll = debounce(handleScroll, 300);
    window.addEventListener('scroll', debouncedHandleScroll)
    return () => {
      window.removeEventListener('scroll', debouncedHandleScroll)
    }
  }, [])

  useEffect( () => {

    let footerPriceToSet = {
      int: '0',
      cents: '99',
      period: 'por dia',
    }
    const plansWithoutOrtho = firstPlan?.group?.find(plan => !plan.hasOrthodontics) || { plans : [] }; 
    const value = plansWithoutOrtho.plans[0]?.value;
    if(value) {
      const [int, cents] = String(value.replace(/\D/gi, '')/100).split('.')
      
      footerPriceToSet = {
        int,
        cents,
        period: '/mês',
      }
    }
    setFooterPrice(footerPriceToSet)
  }, [affiliate, firstPlan])
 
  return (
    <Styled.Wrapper>
      <ThemeProvider>
        <SnackbarProvider>
          <GlobalStyle />
          <Header />
          <Styled.Main>{children}</Styled.Main>
          <Footer />
          { !hideFixedFooter && <FixedFooter canShow={showDefaultFixedFooter}>
            {
               isIPad && <>
                <Styled.ContractNowText>Contrate online</Styled.ContractNowText>
                <FixedFooterIcon />
              </>
            }
            <Styled.ContractSection>
              <Styled.PriceSection>
                { affiliate ? 
                <Styled.TitlePrice>De <span className="cut"> R$39,99</span> por</Styled.TitlePrice> :
                <Styled.TitlePrice>A partir de</Styled.TitlePrice>
                }
                <Styled.Price>
                  <Styled.Currency>R$</Styled.Currency>
                  <Styled.IntValue>{footerPrice.int}</Styled.IntValue>
                  <Styled.CentsValue>,{footerPrice.cents}</Styled.CentsValue>
                  <Styled.Period>{footerPrice.period}</Styled.Period>
                </Styled.Price>
              </Styled.PriceSection>
              <Button
                variant='contained'
                color='primary'
                className='padding'
                style={{
                  padding: '10px 5px',
                  width: '55%',
                  fontSize: '1rem',
                  borderRadius: '24px',
                  marginTop: 18
                }}
                onClick={() => {
                  const top =
                    document.querySelector('#plansSection').offsetTop - 70
                  window.scrollTo({
                    behavior: 'smooth',
                    left: 0,
                    top
                  })
                }}
              >
                Contrate agora!
              </Button>
            </Styled.ContractSection>
          </FixedFooter>}
        </SnackbarProvider>
      </ThemeProvider>
    </Styled.Wrapper>
  )
}

Layout.defaultProps = {
  hasPaddingTop: true,
  headerHasSlide: true,
  cancelAnimation: false,
  showFooter: true
}

export default memo(Layout)
